import { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../config';

const useRemoveItem = (fetchCart) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleRemoveItem = async (slug) => {
    setLoading(true);
    setError(null);

    try {
      const authToken = localStorage.getItem('authToken');
      const anonymousUserId = localStorage.getItem('anonymousUserID');

      // Prepare headers
      const headers = { 'Content-Type': 'application/json' };

      if (authToken) {
        headers['Authorization'] = `Token ${authToken}`;
      } else if (anonymousUserId) {
        headers['Anonymous-User-ID'] = anonymousUserId;
      }

      console.log('Sending request to remove item:', { slug });

      // Make API request to remove item
      const response = await axios.post(
        `${BASE_URL}/api/remove-item/`,
        { slug }, // Payload
        { headers }
      );

      // Check for a successful status code (200 or 204)
      if (response.status === 200 || response.status === 204) {
        console.log('Item removed successfully, refreshing cart...');
        await fetchCart(); // Refresh the cart data explicitly
      } else {
        throw new Error('Unexpected response from the server.');
      }
    } catch (err) {
      console.error('Error removing item:', err);
      setError(
        err.response?.data?.message || 'Failed to remove item. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return { handleRemoveItem, loading, error };
};

export default useRemoveItem;
